import { combineReducers } from 'redux';
import formReducer from './form';
import customersReducer from './customers';
import sitesReducer from './sites';
import contactsReducer from './contacts';
import dirty from './dirty';

export default combineReducers({
  form: formReducer,
  customers: customersReducer,
  sites: sitesReducer,
  contacts: contactsReducer,
  dirty,
});



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step1/reducers/index.js